import { render, staticRenderFns } from "./DingList.vue?vue&type=template&id=5f09b9df&scoped=true"
import script from "./DingList.vue?vue&type=script&lang=js"
export * from "./DingList.vue?vue&type=script&lang=js"
import style0 from "./DingList.vue?vue&type=style&index=0&id=5f09b9df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09b9df",
  null
  
)

export default component.exports